import './auth/installAuth0FetchProxy';
import { startNewRelicBrowserAgent } from './newRelic';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

startNewRelicBrowserAgent();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();